import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Company } from '../../store/company/types'
import { IUser } from '../../store/interface';
import { fetchRequest as getCourseAction, selectCourse as selectCourseAction } from '../../store/course/actions'
import { fetchRequest as getCourseRecomAction } from '../../store/courseRecommend/actions'
import { fetchRequest as getMyCourseAction, fetchRequest as getMyCourseAction2, selectCourse as selectMyCourseAction } from '../../store/myCourse/actions'
import { getMyCourseActiveOnly } from '../../store/myCourse/selectors';
import { getCourseRecom } from '../../store/courseRecommend/selectors';
import { getCourseByCategory } from '../../store/course/selectors';
import { getMyCourse } from '../../store/myCourse/selectors';
import { Link, NavLink as RouterNavLink } from 'react-router-dom';
import { Button, Col, Row,  Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge, Collapse  } from 'reactstrap';
import SearchBox from '../courses/searchBox';
import { Redirect } from 'react-router-dom';
import {
    Container, Card, CardImg, CardTitle, CardText, CardGroup,
    CardSubtitle, CardBody, CardFooter
} from 'reactstrap';

// @ts-ignore 
import { Spinner } from 'reactstrap';

import Webcam from 'react-webcam';
import MarketplacePage from '../../pages/Marketplace/index';
import './myCourse.css';
// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    loading: boolean
    coursesByCategory: any[],
    errors?: string,
    data: any,
    dataCourseRecom: any,
    dataCPDPoints: any,
    userDB: IUser
}

interface IState {
    redirect: boolean
    term: string
    profession: string
    country: string
    webcam: any
    year:number
    dropdownYearOpen: boolean
    cpdPointList : any
    cpdPointCalculated : boolean
    cpdPointIsOpen: boolean
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    fetchRequest: typeof getCourseAction
    fetchRequestCourseRecom: typeof getCourseRecomAction
    fetchRequestMyCourse: typeof getMyCourseAction
    fetchRequestMyCPDPoints: typeof getMyCourseAction2
    selectCourse: typeof selectCourseAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch


class MyCoursePage extends React.Component<AllProps, IState> {
    constructor(props: AllProps) {
        super(props);
        
        this.state = {
            redirect: false,
            term: '',
            profession: '',
            year: new Date().getFullYear(), // Default selection to current year
            dropdownYearOpen : false,
            country: '',
            cpdPointList: [],
            webcam : React.createRef(),
            cpdPointCalculated : false,
            cpdPointIsOpen: false
        };
        this.onChangeYear = this.onChangeYear.bind(this);
        this.cpdPointOpen = this.cpdPointOpen.bind(this);
        //this.Search = this.Search.bind(this);
    }

    public componentDidMount() {
        const { fetchRequest: fr, coursesByCategory: dataCourseByCategory } = this.props
        //if (data.length === 0)
        //    fr();

        let professionList = this.props.userDB?.professionList;
        let profession = "";
        if (professionList){
            professionList.map(function (d: any) {
                if (profession != '') profession += ',';
                let pro = '';
                switch (d.profession) {
                    case 'Accountant':
                        pro = 'Accountancy';
                        break;
                    case 'CompanySecretary':
                        pro = 'Company Secretary';
                        break;
                    case 'Tax Agent':
                        pro = 'Tax Agent';
                        break;
                    case 'Contractor':
                        pro = 'Contractor';
                        break;
                    case 'Engineer':
                        pro = 'Engineering';
                        break;
                    default:
                }
                profession += pro;
            });
        }
        //console.log("=> professionList : " + profession);
        //console.log("=> professionList : " + JSON.stringify(professionList));

        const { fetchRequestCourseRecom: fr2, dataCourseRecom: dataCourseRecom } = this.props
        var searchParams: any = {};
        searchParams["offset"] = 0;
        searchParams["limit"] = 4;
        searchParams["searchProfession"] = profession;
        if (dataCourseRecom.length === 0)
            fr2(searchParams);

        const { fetchRequestMyCourse: fr3, data: data } = this.props
        var searchParams3: any = {};
        searchParams3["offset"] = 0;
        searchParams3["limit"] = 10;
        searchParams3["year"] = new Date().getFullYear();
        if (data.length === 0)
            fr3(searchParams3);

            
        const { fetchRequestMyCPDPoints: fr4, dataCPDPoints: dataCPDPoints } = this.props
        var searchParams4: any = {};
        searchParams4["offset"] = 0;
        searchParams4["limit"] = 100;
        searchParams4["year"] = this.state.year;
        if (dataCPDPoints.length === 0)
            fr4(searchParams4);
    }

    componentDidUpdate(prevProps: AllProps) {
        if (prevProps.dataCPDPoints != this.props.dataCPDPoints){
            //var result:any = [];
            var result: {[key: string]: number} = {
            }

            this.props.dataCPDPoints.map(function (d:any) {
                if (d.certIsGenerated){
                    d.cpdPoints.forEach((c: any) => {
                        if (c.profession in result){
                            result[c.profession] += c.points;
                        } else {
                            result[c.profession] = c.points;
                        }
                    });
                }
            });
            this.setState({cpdPointCalculated : true, cpdPointList: result });

        }
    }

    constructCPDPoint(array: any) {
        let data: any = [];

        array.forEach((element: any) => {
            // data.push(element.profession + "(" + element.points + ")");
            data.push(element.profession + " (" + element.cpdRefNo + ")");
        });

        return data.join("; ");
    }

    totalCpdPoinst(array: any) {
        // let sum: number = array.map(a:any => a.value).reduce(function(a:any, b:any)
        // {
        // return a + b;
        // });
        let sum: number = 0;
        //Object.entries(array).forEach((a: any) => sum += a.value);
        Object.entries(this.state.cpdPointList).map(([key,value])=>{
            var y: number = +value;
            sum += y;
        });
        return sum;
    }

    onChangeYear(e:any){
        var selectedYear = e.currentTarget.textContent;
        if (selectedYear === "All") selectedYear = 0;
        this.setState({ year: selectedYear}, () => {
            var searchParams:any = {};
            searchParams["offset"] = 0;
            searchParams["limit"] = 100;
            searchParams["year"] = this.state.year;
            this.props.fetchRequestMyCPDPoints(searchParams);
        });
    }

    cpdPointOpen(e:any){
        this.setState({ cpdPointIsOpen: !this.state.cpdPointIsOpen});
    }

    private Search(d: any) {
        this.setState({
            redirect: true,
            term: d.searchTerm.toLowerCase(),
            profession: d.searchProfession,
            country: d.searchCountry
        }, () => {
        });
    }

    private renderData(item: any) {
        const data: any[] = item.Courses;
        const category: string = item.Category;

        //const { loading, data  } = this.props;
        let perChunk: number = 2;
        let chunkResults = [];
        if (data.length > 0) {
            //let rowLimit: number = data.length;
            let rowLimit: number = 2;

            chunkResults = data.slice(0, rowLimit).reduce((resultArray: any[], item, index) => {
                const chunkIndex = Math.floor(index / perChunk)

                if (!resultArray[chunkIndex]) {
                    resultArray[chunkIndex] = [] // start a new chunk
                }

                resultArray[chunkIndex].push(item)

                return resultArray
            }, []);
        }
        let indexU: number = 0;
        return (
            <Container>
                <Row>
                    <Col>

                    </Col>
                </Row>
                <Row key={"Row" + category}>
                    {
                        //onClick={()=>this.props.selectCompany(hero.id)}
                        chunkResults.map(
                            chunkResult => (
                                <CardGroup sm="3" className="" key={category + "_" + indexU++} >
                                    {
                                        chunkResult.map(
                                            (hero: any) => (

                                                <Card key={hero.id} className="">
                                                    <Row className="no-gutters">
                                                        <Col md="4">
                                                            <CardImg decoding="async" top width="100%" src={hero.Image} alt="" />
                                                        </Col>
                                                        <Col md="8">
                                                            <CardBody>
                                                                <CardTitle>{hero.CourseTitle}</CardTitle>
                                                                <CardText></CardText>
                                                                <RouterNavLink to={"/Course/Play/" + hero.id + "/1"}><Button type="button" className="btn btn-primary btn btn-secondary">Attend Now</Button></RouterNavLink>
                                                            </CardBody>
                                                        </Col>
                                                    </Row>
                                                </Card>

                                            )
                                        )}
                                </CardGroup>
                            )
                        )
                    }
                </Row>
            </Container>
        )
    }

    GetImagePath(fileName: string){
        fileName = fileName.replace("/courses/","").replace(".jpg","_xs.jpg");
        return "https://images.ultimatespro.com/images/" + fileName;
    }

    public render() {
        const { loading, coursesByCategory, userDB } = this.props
        const toggleDropDrownYear = () => this.setState({dropdownYearOpen : !this.state.dropdownYearOpen}); 

        let videoConstraints = null;
        videoConstraints = {
            width: 192,
            height: 192,
            facingMode: 'user'
          };







        // if (userDB.id === ""){ // If user not update profile, redirect to profile
        //     return (
        //         <Redirect push to={{
        //             pathname: '/profile/'
        //         }} />
        //     )
        // }else{
        //     if (this.state.redirect) {
        //         return (
        //             <Redirect push to={{
        //                 pathname: '/courses/',
        //                 search: '?term=' + this.state.term + "&profession=" + encodeURIComponent(this.state.profession) + "&country=" + this.state.country
        //             }} />
        //             // <Redirect to={"/courses?term=" + this.state.term 
        //             //     + "&profession=" + this.state.profession
        //             //     + "&country=" + this.state.country    
        //             //  } />
        //         )
        //     } else {
        return (
            <div>
                {
                    loading && (
                        <div>Loading Profile <Spinner color="warning"/></div>
                    )
                }
                <br />
                <Row>
                    <Col lg="12"><b>Welcome back, {userDB.fullName}</b></Col>
                    {/* { JSON.stringify(this.props.dataCPDPoints.length) }  */}   
                    {/* { JSON.stringify(this.props.userDB)}  */}
                    <Col lg="8">
                        <React.Fragment>
                            <Card className="ml-1 mr-1">
                                <CardBody style={{padding:"1rem"}}>
                                    <CardTitle style={{marginBottom:"0rem"}}>
                                        <table style={{width:"100%"}}>
                                            <tr>
                                                <td style={{width:"48%"}}>
                                                    <b>Your total accumulated learning hours in Year</b>
                                                </td>
                                                <td style={{width:"10%", paddingLeft:"10px", paddingRight:"10px"}}>
                                                    <Dropdown isOpen={this.state.dropdownYearOpen} size="sm" toggle={toggleDropDrownYear} block>
                                                        <DropdownToggle caret>{this.state.year == 0 ? "All": this.state.year}</DropdownToggle>
                                                        <DropdownMenu>
                                                            <DropdownItem header>Choose Year</DropdownItem>
                                                            <DropdownItem divider />
                                                            <DropdownItem onClick={this.onChangeYear}>All</DropdownItem>
                                                            <DropdownItem onClick={this.onChangeYear}>2020</DropdownItem>
                                                            <DropdownItem onClick={this.onChangeYear}>2021</DropdownItem>
                                                            <DropdownItem onClick={this.onChangeYear}>2022</DropdownItem>
                                                            <DropdownItem onClick={this.onChangeYear}>2023</DropdownItem>
                                                            <DropdownItem onClick={this.onChangeYear}>2024</DropdownItem>
                                                            <DropdownItem onClick={this.onChangeYear}>2025</DropdownItem>
                                                        </DropdownMenu>
                                                    </Dropdown>
                                                </td>
                                                <td><b>is </b></td>
                                                <td style={{fontWeight:700, fontSize: "30px", width:"10%", paddingLeft:"10px", paddingRight:"10px"}}>
                                                    {this.totalCpdPoinst(this.state.cpdPointList)}
                                                </td>
                                                <td style={{paddingTop:"15px"}}>
                                                    <Button color="primary" size="sm" onClick={this.cpdPointOpen} style={{ marginBottom: '1rem' }}>Show Details</Button>
                                                </td>
                                                { !this.state.cpdPointCalculated && <td><Spinner color="primary"/></td> }
                                            </tr>
                                        </table>
                                    </CardTitle>
                                    <Collapse isOpen={this.state.cpdPointIsOpen}>
                                    {
                                        Object.entries(this.state.cpdPointList).map(([key,value])=>{
                                            return <Row>
                                            <Col lg="6" sm="6">
                                                {key}
                                            </Col>
                                            <Col lg="6" sm="6">
                                                {value}
                                            </Col>
                                        </Row>;
                                        })
                                    }
                                    </Collapse>
                                </CardBody>
                            </Card>
                        </React.Fragment>
                    </Col>
                    <Col lg="2">
                    </Col>                        
                </Row>
                {
                    (this.props.data.length > 0) ? (
                        <React.Fragment>
                            <br />
                            <Row>
                                <Col lg="6"><b>Ready to jump back in?</b></Col>
                                <Col lg="6" style={{ textAlign: "right" }}><Link to={'/mycourses/'} >All My Courses</Link></Col>
                            </Row>
                            <Row>
                            {
                                this.props.data.slice(0, 2).map(
                                    (d: any) => (
                                        <Col lg="6" key={d.id}>
                                            <Card className="ml-1 mr-1">
                                                <CardBody>
                                                    <CardTitle><b>{d.courseTitle}</b></CardTitle>
                                                    <Row>
                                                        <Col lg="4">
                                                            <img src={this.GetImagePath(d.videoThumbnailURL)} alt="Skote" className="img-fluid card-img" />
                                                        </Col>
                                                        <Col lg="8">
                                                            Duration: {this.SecondsTohhmmss(d.courseDuration)}
                                                            <br />Credit Hours/Points: <br /> {this.constructCPDPoint(d.cpdPoints)}
                                                            <br />{this.renderPlay(d)}
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    )
                                )}
                            </Row>
                        </React.Fragment>
                    ) : (
                            <React.Fragment>
                                <Row>
                                    <Col></Col>
                                </Row>
                            </React.Fragment>
                        )
                }

                {/* {JSON.stringify(this.props.data)} */}
                {/* <div className="clearfix"></div>
                <div className="row">
                    <div className="col-lg-6">
                        <div className="card">
                            <div className="no-gutters align-items-center row">
                                <div className="col-md-4">
                                    <Link to={'/Course/Play/1/1'} >
                                        <img src="https://localhost:3000/courses/V16.jpg" alt="Skote" className="img-fluid card-img" />
                                    </Link>
                                </div>
                                <div className="col-md-8">
                                    <div className="card-body">
                                        <div className="card-title">Subject Title ABC 123</div>
                                        <p className="card-text">Trainer</p>
                                        <p className="card-text">
                                            <small className="text-muted">1h:01m left . 5 days exipry</small>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="card">
                            <div className="no-gutters align-items-center row">
                                <div className="col-md-4">
                                    <Link to={'/Course/Play/1/1'} >
                                        <img src="https://localhost:3000/courses/V9.jpg" alt="Skote" className="img-fluid card-img" />
                                    </Link>
                                </div>
                                <div className="col-md-8">
                                    <div className="card-body">
                                        <div className="card-title">Subject ABC 123</div>
                                        <p className="card-text">Trainer</p>
                                        <p className="card-text"><small className="text-muted">1h:51m left . 5 days exipry</small></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>*/}
                <br /><br />
                <div>
                    <div className="container">
                        <b>What to learn next</b>
                    </div>
                    <SearchBox onSearch={this.Search.bind(this)}
                        term={this.state.term}
                        profession={this.state.profession}
                        country={this.state.country}
                        loading={this.props.loading} />
                </div>
                <br /><br />
                <div className="container">
                    <b>Recommend for you</b>
                </div>
                <div className="clearfix"></div>
                {/* {JSON.stringify(this.props.dataCourseRecom)} */}

                <Row>
                {
                    this.props.dataCourseRecom.slice(0, 3).map(
                        (d: any) => (
                            <Col lg="4" key={d.id}>
                                <Card key={d.id} className="ml-1 mr-1">
                                    <CardImg decoding="async" top width="100%" src={this.GetImagePath(d.videoThumbnailURL)} alt="" />
                                    <CardBody>
                                        <CardTitle>{d.title}</CardTitle>
                                        <CardText></CardText>
                                    </CardBody>
                                    <CardFooter style={{ textAlign: "center" }}>
                                        <RouterNavLink to={"/courses/" + d.courseId}>
                                            <Button type="button" color="primary" block>Read More</Button></RouterNavLink>
                                    </CardFooter>
                                </Card>
                            </Col>
                        )
                    )}
                </Row>
                <br/><br/>
                
                <div className="container">
                    <Col>
                        <div style={{textAlign:"center"}}>
                            <h4>Payment Method</h4> 
                        </div>
                    </Col>
                </div>
                <div className="clearfix">
                    <Col lg="12" style={{textAlign:"center"}}>
                            <span className="paymentmethod alliance"></span>
                            <span className="paymentmethod affin"></span>
                            <span className="paymentmethod ambank"></span>
                            <span className="paymentmethod bsn"></span>
                            <span className="paymentmethod hsbc"></span>
                            <span className="paymentmethod kuwait"></span>
                            <span className="paymentmethod ocbc"></span>
                            <span className="paymentmethod rhb"></span>
                            <span className="paymentmethod uob"></span>
                    </Col>
                </div>
                <div className="clearfix">
                    <Col lg="12" style={{textAlign:"center"}}>
                        <span className="paymentmethod islam"></span>
                        <span className="paymentmethod muamalat"></span>
                        <span className="paymentmethod cimb"></span>
                        <span className="paymentmethod hongleong"></span>
                        <span className="paymentmethod rakyat"></span>
                        <span className="paymentmethod maybank"></span>
                        <span className="paymentmethod pbebank"></span>
                        <span className="paymentmethod standardcharted"></span>
                    </Col>
                </div>
                <div className="clearfix">
                    <Col lg="12" style={{textAlign:"center"}}>
                        <span className="paymentmethod visa"></span>
                        <span className="paymentmethod master"></span>
                        <span className="paymentmethod boost"></span>
                        <span className="paymentmethod tng"></span>
                        <span className="paymentmethod grab"></span>
                        <span className="paymentmethod maybankqr"></span>
                    </Col>
                </div>
                {/* <br/><br/><br/><br/> */}

            </div>
        )
    }
    
    renderPlay = (item:any) => {
        var expiryDate = new Date(item.orderDT);
        //expiryDate.setDate(expiryDate.getDate() + item.shelfLifeDays);
        expiryDate.setDate(expiryDate.getDate() + parseInt(String(item.shelfLifeDays)));
        var today = new Date();
        if (expiryDate < today){
            return <span>Expired</span>
        }else{
            if (item.verificationType == "noVerification"){
                return <div>
                    <img width='36px' src='data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjMDAwMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTAwIDEwMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZD0iTTE1LjEzNiwyNy4yMTZjMC41NTIsMCwxLTAuNDQ4LDEtMVY5LjU1MmMwLTAuMTQsMC4xMTMtMC4yNTMsMC4yNTMtMC4yNTNoMTYuNjY0YzAuNTUyLDAsMS0wLjQ0OCwxLTFzLTAuNDQ4LTEtMS0xSDE1LjM4OCAgIGMtMC42OTIsMC0xLjI1MywwLjU2MS0xLjI1MywxLjI1M3YxNy42NjRDMTQuMTM2LDI2Ljc2OCwxNC41ODMsMjcuMjE2LDE1LjEzNiwyNy4yMTZ6Ij48L3BhdGg+PHBhdGggZD0iTTg2LjA0NSw3LjI5OUg2OC4zODJjLTAuNTUzLDAtMSwwLjQ0OC0xLDFzMC40NDcsMSwxLDFoMTYuNjYzYzAuMTQsMCwwLjI1MywwLjExMywwLjI1MywwLjI1M3YxNi42NjRjMCwwLjU1MiwwLjQ0NywxLDEsMSAgIHMxLTAuNDQ4LDEtMVY4LjU1MkM4Ny4yOTgsNy44Niw4Ni43MzcsNy4yOTksODYuMDQ1LDcuMjk5eiI+PC9wYXRoPjxwYXRoIGQ9Ik04Ni4yOTgsNzIuOTUzYy0wLjU1MywwLTEsMC40NDctMSwxdjE2LjY2NGMwLDAuMTQtMC4xMTMsMC4yNTMtMC4yNTMsMC4yNTNINjguMzgyYy0wLjU1MywwLTEsMC40NDctMSwxczAuNDQ3LDEsMSwxICAgaDE3LjY2M2MwLjY5MiwwLDEuMjUzLTAuNTYxLDEuMjUzLTEuMjUzVjczLjk1M0M4Ny4yOTgsNzMuNCw4Ni44NSw3Mi45NTMsODYuMjk4LDcyLjk1M3oiPjwvcGF0aD48cGF0aCBkPSJNMzMuMDUyLDkwLjg3SDE2LjM4OGMtMC4xNCwwLTAuMjUzLTAuMTEzLTAuMjUzLTAuMjUzVjczLjk1M2MwLTAuNTUzLTAuNDQ4LTEtMS0xcy0xLDAuNDQ3LTEsMXYxNy42NjQgICBjMCwwLjY5MiwwLjU2MSwxLjI1MywxLjI1MywxLjI1M2gxNy42NjRjMC41NTIsMCwxLTAuNDQ3LDEtMVMzMy42MDQsOTAuODcsMzMuMDUyLDkwLjg3eiI+PC9wYXRoPjxwYXRoIGQ9Ik03My4yNDcsMjUuNTgyYy0wLjc3MS0wLjc5LTIuMDM4LTAuODA1LTIuODI4LTAuMDMzTDUxLjQzMyw0NC4wOThMMzIuMTMxLDI1LjQ5MWMtMC43OTQtMC43NjYtMi4wNi0wLjc0NC0yLjgyOCwwLjA1MiAgIGMtMC43NjcsMC43OTUtMC43NDMsMi4wNjIsMC4wNTIsMi44MjhsMTkuMjE2LDE4LjUyM0wyOC41MzMsNjYuNDcxYy0wLjc5MSwwLjc3Mi0wLjgwNSwyLjAzOC0wLjAzMywyLjgyOCAgIGMwLjM5MiwwLjQwMSwwLjkxMSwwLjYwMywxLjQzMSwwLjYwM2MwLjUwNCwwLDEuMDA5LTAuMTg5LDEuMzk3LTAuNTY5bDIwLjEyNC0xOS42NjFsMjAuMDYyLDE5LjMzOSAgIGMwLjM4OCwwLjM3NSwwLjg4OCwwLjU2MSwxLjM4OCwwLjU2MWMwLjUyMywwLDEuMDQ4LTAuMjA1LDEuNDM5LTAuNjEyYzAuNzY3LTAuNzk1LDAuNzQ0LTIuMDYxLTAuMDUyLTIuODI3TDU0LjMxNCw0Ni44NzUgICBMNzMuMjEzLDI4LjQxQzc0LjAwNCwyNy42MzgsNzQuMDE4LDI2LjM3Miw3My4yNDcsMjUuNTgyeiI+PC9wYXRoPjxwYXRoIGQ9Ik0zNi40NjEsMjguNjhjMC40OTgsMC4yMzYsMS4wOTUsMC4wMjEsMS4zMzEtMC40NzljMi4zMTEtNC45MTIsNi42NDktNy40MDIsMTIuODkzLTcuNDAyICAgYzYuNTA1LDAsMTAuOTY3LDIuNjgxLDEzLjI2LDcuOTY3YzAuMTYzLDAuMzc3LDAuNTMxLDAuNjAzLDAuOTE4LDAuNjAzYzAuMTMyLDAsMC4yNjgtMC4wMjcsMC4zOTYtMC4wODMgICBjMC41MDctMC4yMiwwLjczOS0wLjgwOSwwLjUyLTEuMzE1Yy0xLjgxNC00LjE4NC01LjkwNi05LjE3MS0xNS4wOTQtOS4xNzFjLTYuOTg2LDAtMTIuMDcsMi45NTctMTQuNzAyLDguNTUgICBDMzUuNzQ3LDI3Ljg0OSwzNS45NjEsMjguNDQ1LDM2LjQ2MSwyOC42OHoiPjwvcGF0aD48cGF0aCBkPSJNNjUuMzg4LDM3Ljc4OEM2NS4xMzksNDIuNTcsNjQuMjI0LDQ5Ljg0Miw2My4wMiw1My45Yy0wLjE1NywwLjUyOSwwLjE0NiwxLjA4NiwwLjY3NSwxLjI0MyAgIGMwLjA5NSwwLjAyOCwwLjE5LDAuMDQxLDAuMjg0LDAuMDQxYzAuNDMyLDAsMC44My0wLjI4MSwwLjk1OS0wLjcxNmMxLjI2MS00LjI1LDIuMTg3LTExLjU1NywyLjQ0OC0xNi41NzYgICBjMC4wMjgtMC41NTItMC4zOTYtMS4wMjItMC45NDctMS4wNTFDNjUuODg2LDM2LjgwMiw2NS40MTcsMzcuMjM2LDY1LjM4OCwzNy43ODh6Ij48L3BhdGg+PHBhdGggZD0iTTM3LjcyMiw1NS43OGMwLjEwMywwLDAuMjA4LTAuMDE2LDAuMzEyLTAuMDVjMC41MjUtMC4xNzMsMC44MTEtMC43MzcsMC42MzgtMS4yNjNjLTEuNDA5LTQuMjktMi4zNDQtMTIuNDgyLTIuNTU3LTE2LjkzICAgYy0wLjAyNy0wLjU1Mi0wLjUyOS0wLjk3Mi0xLjA0Ny0wLjk1MWMtMC41NTIsMC4wMjctMC45NzgsMC40OTUtMC45NTEsMS4wNDdjMC4yMDQsNC4yNDYsMS4xMDUsMTIuNzQsMi42NTUsMTcuNDU5ICAgQzM2LjkxLDU1LjUxNCwzNy4zMDEsNTUuNzgsMzcuNzIyLDU1Ljc4eiI+PC9wYXRoPjxwYXRoIGQ9Ik03NC4zMjUsODAuODE1YzAuNDE1LDAsMC44MDMtMC4yNiwwLjk0NS0wLjY3NWMwLjE4LTAuNTIxLTAuMDk4LTEuMDkxLTAuNjItMS4yNzFjLTAuMDk3LTAuMDMzLTkuNjY2LTMuMzY2LTEyLjIzNS03LjYzMSAgIGMtMC4yNjktMC43Ni0yLjIyMi02LjQ2OC0xLjc5OC05LjkzYzAuMDA0LTAuMDM0LTAuMDA4LTAuMDY1LTAuMDA4LTAuMDk5YzAuMDc1LTAuMzI0LDAuMDA1LTAuNjc2LTAuMjQ3LTAuOTI5ICAgYy0wLjM5LTAuMzkyLTEuMDI0LTAuMzk1LTEuNDE0LTAuMDA0Yy0wLjY0NCwwLjY0MS0xLjMzMSwxLjI1My0yLjA0MywxLjgyMWMtMi4zNDksMS44Ny00LjY0NiwyLjk4Ny02LjE0OCwyLjk4NyAgIGMtMS41MDEsMC0zLjc5OS0xLjExNy02LjE0Ny0yLjk4N2MtMC41MzktMC40MjktMS4wNjktMC44OS0xLjU3Ni0xLjM2OGMtMC40MDItMC4zNzctMS4wMzYtMC4zNi0xLjQxNCwwLjA0MSAgIGMtMC4xNTEsMC4xNi0wLjIyMSwwLjM1OC0wLjI0NywwLjU2Yy0wLjA2MywwLjE0OC0wLjEwNCwwLjMwNy0wLjA4OCwwLjQ3OWMwLjMyLDMuNDQzLTEuNzAxLDguNzA2LTEuOTU0LDkuMzUxICAgYy0yLjU1Myw0LjI2Ni0xMi4xNDgsNy42MTEtMTIuMjQ2LDcuNjQ1Yy0wLjUyMiwwLjE4LTAuNzk5LDAuNzQ5LTAuNjIsMS4yNzFjMC4xNDMsMC40MTUsMC41MywwLjY3NSwwLjk0NSwwLjY3NSAgIGMwLjEwOCwwLDAuMjE4LTAuMDE4LDAuMzI1LTAuMDU1YzAuNDI3LTAuMTQ2LDEwLjQ4OS0zLjY1NCwxMy4zNTktOC41OTFsMC4wNjItMC4xMjZjMC4wODctMC4yMTQsMS44My00LjU1MiwyLjExNi04LjM5NCAgIGMwLjAzMSwwLjAyNSwwLjA1OSwwLjA1MywwLjA5LDAuMDc4YzIuNzcxLDIuMjA3LDUuMzk3LDMuNDIzLDcuMzk0LDMuNDIzYzEuOTk3LDAsNC42MjMtMS4yMTYsNy4zOTUtMy40MjMgICBjMC4xNTEtMC4xMiwwLjI5NS0wLjI1MSwwLjQ0NC0wLjM3NWMwLjI0NSwzLjkyNywxLjg4NSw4LjQ4OSwxLjk2OSw4LjcxOGwwLjA3NSwwLjE2MWMyLjg3MSw0LjkzNywxMi45MzMsOC40NDUsMTMuMzU5LDguNTkyICAgQzc0LjEwNyw4MC43OTgsNzQuMjE4LDgwLjgxNSw3NC4zMjUsODAuODE1eiI+PC9wYXRoPjwvZz48L3N2Zz4=' />
                    <Link to={'/mycourses/' + item.id} className="btn btn-success">Attend Now</Link>
                </div>
            } else{
                return <div>
                    <img width='36px' src='data:image/svg+xml;base64,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' />    
                    <Link to={'/mycourses/' + item.id} className="btn btn-success">Attend Now</Link>
                </div>
            }
        }
    }
        
    SecondsTohhmmss(totalSeconds:number) {
        if (totalSeconds < 0){
            return "-";
        }

        totalSeconds = Math.trunc(totalSeconds);
        var hours   = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);
        var seconds = totalSeconds - (hours * 3600) - (minutes * 60);
    
        // round seconds
        seconds = Math.round(seconds * 100) / 100
    
        var result = (hours < 10 ? "0" + hours : hours);
            result += ":" + (minutes < 10 ? "0" + minutes : minutes);
            result += ":" + (seconds  < 10 ? "0" + seconds : seconds);
        if (result === "00:00:00"){
            result = "-";
        }
        return result;
    }

 }

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    loading: state.company.ui.loading,
    errors: state.company.ui.errors,
    //userDB: state.userReducer,
    userDB: state.userInfo.byId[0],
    coursesByCategory: getCourseByCategory(state),
    dataCourseRecom: getCourseRecom(state),
    dataCPDPoints: getMyCourse(state),
    data: getMyCourseActiveOnly(state, 2)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    fetchRequest: getCourseAction,
    fetchRequestCourseRecom: getCourseRecomAction,
    fetchRequestMyCourse: getMyCourseAction,
    fetchRequestMyCPDPoints: getMyCourseAction2,
    selectCompany: selectCourseAction,
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MyCoursePage)
